import { ColumnDefinition } from 'features/gridReport/models';
import { getMainCount } from './getMainCount';

export function getMainAndOffcanvasFilters(
  filterableColumns: ColumnDefinition[]
) {
  const mainCount = getMainCount(filterableColumns);
  const mainFilters = filterableColumns.slice(0, mainCount);
  const offcanvasFilters = filterableColumns.slice(mainCount);
  return { mainFilters, offCanvasFilters: offcanvasFilters };
}
